<template>
  <section class="chapter-1">
    <div class="bg-light chapter-1-panel-1">
      <FlexWrap above>
        <div id="build-city-trigger"></div>
        <header class="header">
          <Year class="year">1815</Year>
          <Title>Ridders, boeren <br>en steden</Title>
        </header>
        <div class="container">
          <BuildCity />
          <Content>
            <p>Wie je ook hebt gekozen, de kans dat je had mogen stemmen in 1815 is heel klein. Alleen rijke mannen van boven de 23 jaar hadden kiesrecht, in die tijd nog geen 4 procent van de totale bevolking. Een schijntje dus!</p>
          </Content>
          <Content>
            <p>De gelukkigen die bij die 4 procent hoorden, kwamen uit verschillende groepen: ze vertegenwoordigden de steden, het platteland en… de ‘ridderschappen’.</p>
          </Content>
        </div>
      </FlexWrap>
    </div>
    <div class="bg-blue chapter-1-panel-2">
      <FlexWrap>
        <div class="container">
          <Content dark>
            <p>Klinkt spannend: ridders. Maar dat waren gewoon rijke mensen van adel, zoals baronnen en graven.</p>
          </Content>
        </div>
        <KnightToMan />
        <div class="container">
          <Content dark>
            <p>Nu zouden we dat stemmen niet erg democratisch noemen. Maar dat was toen maar goed ook, vond de regerende elite. Democratie vonden die bestuurders maar een eng woord, dat deed denken aan onrust en revolutie. Dat wilde toch niemand?</p>
          </Content>
        </div>
        <Handshake />
        <div class="container">
          <Content dark>
            <p>Nou, blijkbaar wel.</p>
            <p>Want halverwege de negentiende eeuw braken overal in Europa revoluties uit. Het ging economisch slecht, er was veel onzekerheid en mensen wilden meepraten over hun toekomst. Er moest wat veranderen.</p>
          </Content>
        </div>
      </FlexWrap>
      <div class="chapter-1-city">
        <img
          :src="require('@/assets/images/smoke.gif')"
          alt=""
          draggable="false"
          class="smoke smoke-1"
        />
        <img
          :src="require('@/assets/images/smoke.gif')"
          alt=""
          draggable="false"
          class="smoke smoke-2"
        />
        <img
          :src="require('@/assets/images/city.png')"
          alt=""
          draggable="false"
          class="city"
        />
      </div>
    </div>
    <div class="bg-dark chapter-1-end">
      <div class="container">
        <Accordion class="accordion" track="accordion-de-dierentuin-van-de-koning">
          <template slot="title">De dierentuin van de koning</template>
          <template slot="explanation">
            <p>In 1815 was het stemrecht ingewikkelder geregeld dan nu. Niet voor iedereen golden dezelfde regels.</p>
            <p>Zo stemde je als rijke stedeling of vermogende plattelandsbewoner niet op een politicus, maar op een speciaal kiescollege. In de stad koos dat kiescollege vervolgens de gemeenteraad, de gemeenteraad stemde voor de Provinciale Staten en daar kozen ze de Tweede Kamer. Op het platteland werd de stap van de gemeenteraad overgeslagen, maar dan nog: er zaten heel veel lagen tussen jou en de Tweede Kamer.</p>
            <p>Wilde je meer directe invloed? Dat kon eigenlijk alleen als je bij de ridderschappen hoorde. Mannen van adel mochten namelijk direct stemmen voor de Provinciale Staten en dus indirect voor de Tweede Kamer. Die ridderschappen kozen natuurlijk wel vaak iemand uit hun adellijke midden.</p>
            <p>Ook de Eerste Kamer zat vol met adel. Toen die in 1815 ontstond, bepaalde de koning wie daarin terechtkwam. Je raadt het al: vooral zijn vrienden en bekenden, de edellieden. Sterker nog: de Eerste Kamer werd in die tijd vaak de ‘dierentuin van de koning’ genoemd.</p>
          </template>
        </Accordion>
      </div>
    </div>
  </section>
</template>

<script>
import { Year, Title, Content, FlexWrap } from '@/components/chapter'
import KnightToMan from './knight-to-man'
import Handshake from './Handshake'
import BuildCity from './build-city'
import { chapterMixin } from '@/mixins'
import Accordion from '@/components/Accordion'

export default {
  name: 'Chapter1',
  mixins: [chapterMixin],
  components: {
    Year,
    Title,
    Content,
    KnightToMan,
    Accordion,
    FlexWrap,
    BuildCity,
    Handshake
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 2;
}

.year {
  color: $c-blue;
}

.chapter-1-city {
  position: relative;
  font-size: 0;
  height: 133px;
  width: 1144px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 1144px) {
    width: 100%;
  }
}

.chapter-1-panel-2 {
  overflow: hidden;

  .container {
    position: relative;
    z-index: 1;
  }
}

.chapter-1-end {
  padding: 50px 0 20px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    background-color: $c-dark;
    height: 10px;
  }

  @media (min-width: 768px) {
    padding: 90px 0 50px;
  }
}

.accordion {
  margin: 0 auto;
  border: 1px solid white;
}

.smoke {
  position: absolute;
  bottom: 40px;
  width: 162px;

  @media (min-width: 1144px) {
    width: 12vw;
  }

  &-1 {
    left: 385px;

    @media (min-width: 1144px) {
      left: 15%;
    }
  }

  &-2 {
    right: 291px;

    @media (min-width: 1144px) {
      right: 20%;
    }
  }
}

.city {
  height: 133px;
  position: absolute;
  bottom: 0;
  width: 1144px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;

  @media (min-width: 1144px) {
    width: 100%;
    height: auto;
  }
}
</style>
